import { Component } from '@angular/core';

@Component({
  selector: 'app-version-history-settings',
  standalone: true,
  imports: [],
  templateUrl: './version-history-settings.component.html',
  styleUrl: './version-history-settings.component.scss'
})
export class VersionHistorySettingsComponent {

}
